module.exports = __webpack_public_path__ + "img/rk.091ec83b.png";